import { Config } from '@/config';
import { ApiService } from '@/services/api.service';

const base = () => `${Config.api.tender.url}pre-project-views`;

class PreProjectViewsService {
  list() {
    return ApiService.get(base()).then((response) => response.data);
  }

  create(view) {
    return ApiService.post(base(), view).then((response) => response.data);
  }

  update(id, patch) {
    return ApiService.put(`${base()}/${id}`, patch).then((response) => response.data);
  }

  remove(id) {
    return ApiService.delete(`${base()}/${id}`).then((response) => response.data);
  }

  // Persist this user's order of their visible views (send the full ordered id list).
  reorder(orderedIds) {
    return ApiService.put(`${base()}/order`, { orderedIds }).then((response) => response.data);
  }
}

export const preProjectViewsService = new PreProjectViewsService();
